<!--
  ~ Copyright 2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">Global Payments</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="
              merchant.accountDetails.globalPaymentsAccountDetails &&
              hasFinanceRole() &&
              isMerchantActive() &&
              !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Account Details
          </button>
        </div>
      </legend>
      <div class="col-md-12 mt-3 removePadding" *ngIf="!editable">
        <div class="table-block">
          <div class="recordRow">
            <div class="recordLabel">Name</div>
            <div id="globalPaymentsMerchantName" class="recordValue">
              {{
                merchant.accountDetails.globalPaymentsAccountDetails
                  ?.globalPaymentsMerchantName
              }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Global Payments Site ID</div>
            <div id="globalPaymentsSiteId" class="recordValue">
              {{
                merchant.accountDetails.globalPaymentsAccountDetails
                  ?.globalPaymentsSiteId
              }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Key</div>
            <div id="globalPaymentsKey" class="recordValue">
              {{
                merchant.accountDetails.globalPaymentsAccountDetails
                  ?.globalPaymentsKey
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" *ngIf="editable">
        <form
          name="globalPaymentsFormControl"
          class="form-horizontal"
          novalidate
          [formGroup]="globalPaymentsFormGroup"
          (submit)="updateGlobalPaymentsDetails()"
        >
          <app-global-payments-details-edit
            [globalPaymentsFormGroup]="globalPaymentsFormGroup"
          ></app-global-payments-details-edit>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="globalPaymentsFormGroup.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
